// src/hooks/useApiAuth.js
import { useAuth } from '@clerk/clerk-react';
import { useCallback } from 'react';

export function useApiAuth() {
  const { getToken } = useAuth();

  const authFetch = useCallback(async (url, options = {}) => {
    const token = await getToken();
    const headers = { ...options.headers, Authorization: `Bearer ${token}` };

    if (options.body && typeof options.body === 'object' && !(options.body instanceof FormData) && !(options.body instanceof Blob) && !(options.body instanceof ArrayBuffer)) {
      headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(options.body);
    }

    const res = await fetch(url, { ...options, headers });
    if (!res.ok) {
      const err = await res.json().catch(() => ({ error: 'Request failed' }));
      throw new Error(err.error || 'Request failed');
    }
    return res.json();
  }, [getToken]);

  return { authFetch };
}
